import storeRoot from '../store-root'
import http from '../../services/http'

const moduleName = 'equipmentSocket'

storeRoot.registerModule(moduleName, {
  namespaced: true,
  state: {
    swiths: [],
    sensors: [],
    swithTimer: []
  },
  actions: {
    async getEquipmentSocket ({ commit }, payload) {
      console.log(4444)
      try {
        let result = await http.get(`/api/EquipmentSocket/${payload.id}?isGetRealTimeData=${payload.isGetRealTimeData}`)
        commit('setEquipmentSocket', result.data)
        return result.data
      } catch (err) {
        commit('setEquipmentSocket', {sensors: [], swiths: []})
        return {sensors: [], swiths: []}
      }
    },
    // 获取开关编辑视图
    async getSwithEditView ({ commit }, payload) {
      let result = await http.get(`/api/EquipmentSocket/GetSwithEditView/${payload}`)
      return result.data
    },
    // 编辑开关
    async updateSwith ({ commit }, payload) {
      let result = await http.put(`/api/EquipmentSocket/UpdateSwith/${payload.data.id}`, payload.data)
      commit('updateCurrentSwitch', payload)
      return result.data
    },
    // 编辑水质参数
    async updateSensor ({ commit }, payload) {
      let result = await http.put(`/api/EquipmentSocket/UpdateSensor`, payload.arr)
      commit('updateEquipmentSensor', payload)
      return result
    },
    // 首页编辑水质参数
    async indexUpdateSensor ({ commit }, payload) {
      let result = await http.put(`/api/EquipmentSocket/UpdateSensor`, payload)
      // commit('updateEquipmentSensor', payload)
      return result
    },
    // 获取自动开关数据
    async swithTimer ({ commit }, payload) {
      let result = await http.get(`/api/SwithTimer/${payload}`)
      return result.data
    },
    // 编辑自动开关数据
    async updateSwithTimer ({ commit }, payload) {
      let result = await http.put(`/api/SwithTimer/${payload.id}`, payload.saveArr)
      return result
    },
    // 删除自动开关数据
    async deleteSwithTimer ({ commit }, payload) {
      let result = await http.delete(`/api/SwithTimer/${payload}`)
      return result
    },
    // 切换时间开关控制状态
    async changeSwitchStatus ({ commit }, payload) {
      let result = await http.put(`/api/SwithTimer/Switch?id=${payload}`)
      return result.data
    },
    // 远程控制开关
    async remoteCtrl ({ commit }, payload) {
      let result = await http.put(
        `/api/EquipmentSocket/RemoteCtrl?id=${payload.rtuId}&indexCtrl=${
          payload.indexCtrl
        }&switchEnum=${payload.switchEnum}`
      )
      return result.data
    },
    // 获取上下限数据
    async swithUpDownLimit ({ commit }, payload) {
      let result = await http.get(`/api/SwithLimit/${payload}`)
      return result.data
    },
    // 编辑上下限数据
    async updateSwithUpDownLimit ({ commit }, payload) {
      let result = await http.put(`/api/SwithLimit/${payload.id}`, payload.saveArr)
      return result
    },
    // 删除上下限数据
    async deleteUpDownLimit ({ commit }, payload) {
      let result = await http.delete(`/api/SwithLimit/${payload}`)
      return result
    },
    // 切换上下限控制状态
    async changeUpDownLimit ({ commit }, payload) {
      let result = await http.put(`/api/SwithLimit/Switch?id=${payload}`)
      return result.data
    }

  },
  mutations: {
    setEquipmentSocket (state, payload) {
      console.log(payload)
      state.swiths = payload.swiths
      payload.sensors.forEach(element => {
        Object.defineProperty(element, 'range', {
          get () {
            return [element.lowerLimit, element.upperLimit]
          }
        })
      })
      state.sensors = payload.sensors
    },
    setSwitch (state, payload) {
      payload.item.on = payload.value
      state.swiths = state.swiths
    },
    updateCurrentSwitch (state, payload) {
      // state.swiths = state.swiths.splice
      console.log(payload)
      // let kk = state.swiths.find(i => i.id === payload.id)
      state.swiths.splice(payload.data.index, 1, payload.data)
    },
    updateEquipmentSensor (state, payload) {
      state.sensors = payload.sensors
    },
    updateSensorSlider (state, payload) {
      let sensor = state.sensors.find(f => f === payload.sensor)
      if (!sensor || !payload.min || !payload.max) return
      sensor.lowerLimit = payload.min
      sensor.upperLimit = payload.max
    }
  }

})

export default moduleName
